// Skal holdes i sync med @Common/Utilities/PasswordPolicy.cs - backend validerer altid igen

export const PasswordMinLength = 12;
export const PasswordMaxLength = 128;
const MinUniqueCharacters = 5;

const CommonWords = new Set<string>([
    "password", "passw", "adgangskode", "kodeord", "qwerty", "qwertyuiop", "asdfgh", "asdfghjkl", "zxcvbn",
    "abc", "abcdef", "letmein", "welcome", "velkommen", "admin", "administrator", "login", "test", "secret",
    "sommer", "vinter", "efteraar", "efterår", "foraar", "forår", "januar", "februar", "marts", "april", "maj",
    "juni", "juli", "august", "september", "oktober", "november", "december", "danmark", "denmark",
    "uhrevind", "vindmølle", "vindmoelle", "vindmolle", "iloveyou", "monkey", "dragon", "football"
]);

export const PasswordRequirementsText = `Mindst ${PasswordMinLength} tegn. Brug gerne en sætning af flere ord - store bogstaver, tal og specialtegn er ikke et krav.`;

/** Returnerer en fejlbesked, eller undefined hvis adgangskoden er godkendt */
export const validatePassword = (password: string, email?: string): string | undefined => {
    if(!password || password.length < PasswordMinLength) {
        return `Adgangskoden skal være på mindst ${PasswordMinLength} tegn.`;
    }

    if(password.length > PasswordMaxLength) {
        return `Adgangskoden må højst være på ${PasswordMaxLength} tegn.`;
    }

    if(new Set(password.split("")).size < MinUniqueCharacters) {
        return `Adgangskoden skal indeholde mindst ${MinUniqueCharacters} forskellige tegn.`;
    }

    if(/^\d+$/.test(password)) {
        return "Adgangskoden må ikke kun bestå af tal.";
    }

    if(email) {
        const lowerPassword = password.toLowerCase();
        const localPart = email.split("@")[0].toLowerCase();
        if(lowerPassword.includes(email.toLowerCase()) || (localPart.length >= 4 && lowerPassword.includes(localPart))) {
            return "Adgangskoden må ikke indeholde din e-mail.";
        }
    }

    // Bogstaver er tegn med forskellig store/lille-form (inkl. æøå)
    const letters = password.split("").filter(c => c.toLowerCase() !== c.toUpperCase()).join("").toLowerCase();
    if(letters.length === 0 || CommonWords.has(letters)) {
        return "Adgangskoden er for nem at gætte. Brug f.eks. en sætning af flere ord.";
    }

    return undefined;
}
